import {Service} from '@frontapp/editor-html';
import {
  ServiceSubscription as DefaultServiceSubscription,
  ServiceSubscriptionProps as DefaultServiceSubscriptionProps,
} from '@frontapp/editor-html/lib/react';
import React from 'react';

import {buildWindow} from '../../../../libs/shared/helpers/src/browser/browserHelpers';
import {useLayer} from '../../../../libs/shared/ui/src/components/layers/layerContext';

/*
 * Props.
 */

type ServiceOrServices = Service | {[key: string]: Service};

interface ServiceSubscriptionProps<S extends ServiceOrServices>
  extends Omit<DefaultServiceSubscriptionProps<S>, 'window'> {}

/*
 * Component.
 */

export const ServiceSubscription = <S extends ServiceOrServices>(props: ServiceSubscriptionProps<S>) => {
  const {window} = useLayer();
  const {source, filter, children} = props;

  return (
    <DefaultServiceSubscription source={source} filter={filter} window={buildWindow(window)}>
      {children}
    </DefaultServiceSubscription>
  );
};
